import { toast } from 'react-toastify'
import Immutable from 'immutable'

import { createAxiosInstance, attachFilesToEntity } from '../utils/helpers'
import { API_URL } from '.'
import * as types from './types'
import history from '../utils/history'

import { displayMessages, uploadFiles} from './common'

export function getCotizaciones(page = 1) {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const showRecords = getState().externoscotizaciones.get('showRecords')
		const orderBy = getState().externoscotizaciones.get('orderBy')
		const filters = getState().externoscotizaciones.getIn(['modalFilter', 'filters']).filter(x => x.get('apply')).toJS()
		const having = []

		axios.get(`${API_URL}/externos/cotizaciones`, { params: { estado: 1, page, showRecords, orderBy, filters, having }})
		.then((res) => {
			const data = res.data.data.map(x => {
				x.visible = true
				x.selected = false
				return x
			})
			const totalRecords = Number(res.data.totalRecords)
			const fn1 = d => d({ type: types.OBTENER_EXTERNOS_COTIZACIONES, payload: { data, page, totalRecords } })
			fn1(dispatch)
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})

	}
}

export function changeRecordsToShow(showRecords) {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_COTIZACIONES, payload: showRecords })
        const fn1 = (d) => d(getCotizaciones(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function filterCotizaciones(term) {
	return (dispatch) => {
		dispatch({ type: types.FILTRAR_EXTERNOS_COTIZACIONES, payload: term })
	}
}

export function setOrderBy(field) {
	return (dispatch, getState) => {
		let current = getState().externoscotizaciones.get('orderBy')
		current = current.set('field', field.value)
		if (field === null) {
			current = current.set('asc', false)
		} else {
			current = current.set('asc', !current.get('asc'))
		}

        const fn0 = (d) => d({ type: types.ORDENAR_EXTERNOS_COTIZACIONES, payload: { orderBy: current } })
        const fn1 = (d) => d(getCotizaciones(1))
        fn0(dispatch)
        fn1(dispatch)
	}
}

export function showHideModalFilter(state, tableCols) {
    return (dispatch) => {
        dispatch({ type: types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES, payload: { state, tableCols } })
    }
}

export function addModalFilterCriteria() {
    return (dispatch) => {
        dispatch({ type: types.ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES })
    }
}

export function removeCheckedModalFilterCriterias() {
    return (dispatch) => {
        dispatch({ type: types.ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES })
    }
}

export function toggleCheckedModalFilterCriterias(index, checked) {
    return (dispatch) => {
        dispatch({ type: types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES, payload: { index, checked } })
    }
}

export function updateModalFilterCriteria(index, attr, value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES, payload: { index, attr, value } })
    }
}

export function applyFilterCriterias() {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.APLICAR_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES })
        const fn1= (d) => d(getCotizaciones(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function showHideModalSummary(show, id) {
	const axios = createAxiosInstance()

    return (dispatch) => {
		axios.get(`${API_URL}/externos/cotizaciones`, { params: { id }})
		.then((res) => {
			const fn1 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES, payload: { show, data: res.data }})
			fn1(dispatch)
		})
		.catch((err) => {
            console.log(err)
			displayMessages(dispatch, err)
		})
    }
}




export function showHideModalSummaryCotizaciones(show, solicitud_id) {

	const axios = createAxiosInstance()

    return (dispatch) => {
		if (show) {
			axios.get(`${API_URL}/externos/cotizaciones/solicitud`, { params: { id: solicitud_id }})
			.then((res) => {

				const fn1 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD, payload: { show, data: res.data }})
				fn1(dispatch)
			})
			.catch((err) => {
				console.log(err)
				displayMessages(dispatch, err)
			})
		} else {
			const fn2 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD, payload: { show }})
			fn2(dispatch)
		}
	}

}




export function registerCotizacion(id, result) {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const fn0 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES, payload: { show: false }})

		const data = getState().externoscotizaciones.getIn(['modalSummary', 'data']).set('result', result)

		const modificaciones = []

		let files = []

		files = attachFilesToEntity('Cotizacione', [data])

		const errors = validateCotizacion(data)
		if (errors.length > 0) {

			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})

		} else {

			modificaciones.push({
				id: data.get('id'),
				entity: 'Cotizacione',
				value: { 
					estado: result, 
					fecha_entrega: data.get('fecha_entrega'),
					observaciones: data.get('observaciones')
				},
				action: 'edit'
			})


			axios.put(`${API_URL}/externos/cotizaciones/${id}`, modificaciones)
			.then(res => {
				const fn1 = (d) => d(getCotizaciones(1))
				const fn2 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn0, fn1, fn2]))
			})
			.catch(err => {
				displayMessages(dispatch, err)
			})

		}
	}
}



// export function registerSolicitudCotizaciones(solicitud_id) {
// 	const axios = createAxiosInstance()
// 	return (dispatch, getState) => {

// 		const fn0 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD, payload: { show: false }})

// 		const cotizaciones = getState().externoscotizaciones.getIn(['modalSummaryCotizaciones', 'data', 'cotizaciones'])

// 		const modificaciones = []

// 		cotizaciones.valueSeq().forEach(cotizacion => {
// 			modificaciones.push({
// 				id: cotizacion.get('id'),
// 				entity: 'Cotizacione',
// 				value: {					
// 					marca: cotizacion.get('marca'),
// 					cotizado: cotizacion.get('cotizado'),
// 					iva: cotizacion.get('iva'),
// 					cotizado_iva: cotizacion.get('cotizado_iva'),
// 					tiempo_entrega: cotizacion.get('tiempo_entrega'),
// 					estado: 3
// 				},
// 				action: 'edit'
// 			})
// 		})


// 		axios.put(`${API_URL}/externos/cotizaciones/solicitud/${solicitud_id}`, modificaciones)
// 		.then((res) => {

// 			const fn1 = () => toast.success('Las cotizaciones han sido enviadas exitosamente', { bodyClassName: 'toastify-content toastify-success' })
// 			const fn2 = (d) => d(getCotizaciones(1))
// 			dispatch(fn0)
// 			dispatch(fn1)
// 			dispatch(fn2)

// 		})
// 		.catch(err => {
// 			displayMessages(dispatch, err)
// 		})

// 	}
// }


export function registerSolicitudCotizaciones(solicitud_id) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		let dataFiles = Immutable.List()

		const fn0 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD, payload: { show: false }})
		const cotizaciones = getState().externoscotizaciones.getIn(['modalSummaryCotizaciones', 'data', 'solicitud', 'cotizaciones'])
		const archivo = getState().externoscotizaciones.getIn(['modalSummaryCotizaciones', 'data', 'solicitud' , 'cotizaciones' , 0 , 'adjunto'])

		const errors = validateSolicitudCotizaciones(cotizaciones , archivo)

		if (errors.length > 0) {

			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})

		} else {

			const modificaciones = []

			cotizaciones.valueSeq().forEach(cotizacion => {	
				
				dataFiles = dataFiles.push(cotizacion)
	
				if (!cotizacion.get('no_cotizar')) {
					modificaciones.push({
						id: cotizacion.get('id'),
						entity: 'Cotizacione',
						value: {					
							marca: cotizacion.get('marca'),
							cotizado: cotizacion.get('cotizado'),
							iva: cotizacion.get('iva'),
							cotizado_iva: cotizacion.get('cotizado_iva'),
							tiempo_entrega: cotizacion.get('tiempo_entrega'),
							estado: 3
						},
						action: 'edit'
					})
				} else {
					modificaciones.push({
						id: cotizacion.get('id'),
						entity: 'Cotizacione',
						value: {					
							marca: cotizacion.get('marca'),
							cotizado: 0,
							iva: 0,
							cotizado_iva: 0,
							tiempo_entrega: 0,
							estado: 0
						},
						action: 'edit'
					})
				}
	
			})
			
			let files = []
	
			files = attachFilesToEntity('Cotizacione', dataFiles)
			axios.put(`${API_URL}/externos/cotizaciones/solicitud/${solicitud_id}`, modificaciones)
			.then(() => {
				const fn1 = () => toast.success('Las cotizaciones han sido enviadas exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				const fn2 = (d) => d(getCotizaciones(1))
				dispatch(uploadFiles(`/files/${solicitud_id}`, files, [fn0, fn1, fn2]))
			})
			.catch(err => {
				displayMessages(dispatch, err)
			})

		}

	}
}


export function updateInputs(path, value) {
	return (dispatch, getState) => {

        const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES, payload: { path, value } })
		fn0(dispatch)

		const tipomodal = path.split('.')[0]

		if (tipomodal == 'modalSummary') {

			if (path === 'modalSummary.data.iva' || path === 'modalSummary.data.cotizado') {
				const iva = getState().externoscotizaciones.getIn('modalSummary.data.iva'.split('.'))
				const cotizado = getState().externoscotizaciones.getIn('modalSummary.data.cotizado'.split('.'))
				//const cotizado_iva = Math.round(cotizado * (1 + (iva / 100)))
				const cotizado_iva = cotizado * (1 + (iva / 100))
				const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES, payload: { path: 'modalSummary.data.cotizado_iva', value: cotizado_iva } })
				fn1(dispatch)
			}
		}


		if (tipomodal == 'modalSummaryCotizaciones') {

			const attribute = path.split('.').slice(-1)[0]
			const index = path.split('.').slice(-2)[0]

			const cotizaciones = getState().externoscotizaciones.getIn(['modalSummaryCotizaciones', 'data', 'solicitud', 'cotizaciones'])

			const marca = cotizaciones.getIn([index, 'marca'])
			const cotizado = cotizaciones.getIn([index, 'cotizado'])
			const iva = cotizaciones.getIn([index, 'iva'])			
			const tiempo_entrega = cotizaciones.getIn([index, 'tiempo_entrega'])
			const adjunto = cotizaciones.getIn([index, 'adjunto' , 'file'])


			
			if (attribute === 'cotizado' || attribute === 'iva') {
				const cotizado_iva = cotizado * (1 + (iva / 100))
				const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES, payload: { path: `modalSummaryCotizaciones.data.solicitud.cotizaciones.${index}.cotizado_iva`, value: cotizado_iva } })
				fn1(dispatch)
			}

			const check = marca||cotizado||iva||tiempo_entrega||adjunto ? false : true

			const fn2 = (d) => d({ type: types.MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES, payload: { path: `modalSummaryCotizaciones.data.solicitud.cotizaciones.${index}.no_cotizar`, value: check } })
			fn2(dispatch)

		}

	}
}




// export function addFile(path) {
// 	return (dispatch, getState) => {
// 		const data = getState().common.getIn(['modalAddFile', 'data'])
// 		const errors = []
// 		if (!data.get('file')) errors.push('No adicionó ningun archivo')
// 		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
// 		if (data.get('clasificacion') && data.get('clasificacion') != 'Cotizaciones') errors.push('Se requiere adjuntar un archivo de tipo cotización')
// 		if (errors.length > 0) {
// 			errors.forEach(x => {
// 				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
// 			})
// 		} else {
// 			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES, payload: {path, data} })
// 			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
// 			fn1(dispatch)
// 			fn2(dispatch)
// 		}
// 	}
// }




export function addFile(path) {

	return (dispatch, getState) => {

		const data = getState().common.getIn(['modalAddFile', 'data'])
		const errors = []

		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (data.get('clasificacion') && data.get('clasificacion') != 'Cotizaciones') errors.push('Se requiere adjuntar un archivo de tipo cotización')

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES, payload: {path, data} })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
			fn1(dispatch)
			fn2(dispatch)
		}

	}
}








///******* Shared ********///


const validateCotizacion = (data) => {
	const errors = []
	//if (!data.get('cotizado')) errors.push('El valor de la cotización es requerida')
	//if (data.get('cotizado') && data.get('cotizado') == 0) errors.push('El valor de la cotización es requerida')
	if (!data.get('fecha_entrega')) errors.push('El valor de la fecha de entrega es requerida')
	if (!data.get('adjunto')) errors.push('Se requiere adjuntar un archivo con la cotización')
	if (data.get('adjunto') && data.getIn(['adjunto', 'clasificacion']) != 'Cotizaciones') errors.push('Se requiere adjuntar un archivo de tipo cotización')


	return errors
}


const validateSolicitudCotizaciones = (data , archivo) => {

	const errors = []
	let no_cotizados = 0 

	if(archivo == null) errors.push('El Archivo es requerido')
	data.map(cotizacion => {
		const target = cotizacion.getIn(['bienes', 0, 'descripcion'])
		no_cotizados += cotizacion.get('no_cotizar') ? 1 : 0
		if (!cotizacion.get('no_cotizar')) {

			if (!cotizacion.get('marca')) errors.push('La marca es requerida en ' + target)
			if (!cotizacion.get('cotizado')) errors.push('El valor unitario es requerido en ' + target)
			if (!cotizacion.get('iva')) errors.push('El valor del iva es requerido en ' + target)
			if (!cotizacion.get('tiempo_entrega')) errors.push('El tiempo de entrega es requerido en ' + target)

		}

	})
	if (no_cotizados == data.count()) errors.push('No diligenció ninguna cotización para ningún ítem')

	return errors

}


// WEBPACK FOOTER //
// ./src/actions/externoscotizaciones.js